import { gql, useMutation } from '@apollo/client'

export const SELECT_CREATE_GLOBAL_FEED = gql`
  mutation ($input: FeedGlobalCreateUpdate) {
    selectCreateGlobalFeed(input: $input) {
      id
      campaign_id
      created_at
      comments {
        text
        updated_at
        created_at
        author {
          first_name
          last_name
        }
      }
      __typename
    }
  }
`

export const useSelectCreateGlobalStoryFeed = () => {
  const [mutate, { data, loading, error }] = useMutation(SELECT_CREATE_GLOBAL_FEED, {
    update(cache) {
      cache.modify({
        fields: {
          getGlobalizerFeedsByCampaignId() {},
          getFeedsByCampaignId() {},
          getFeeds() {}
        }
      })
    }
  })

  return { mutate, data, loading, error }
}
